export const SIGN_IN_REQUEST = 'AUTH/SIGN_IN/REQUEST';
export const SIGN_IN_SUCCESS = 'AUTH/SIGN_IN/SUCCESS';
export const SIGN_IN_FAILURE = 'AUTH/SIGN_IN/FAILURE';
export const VERIFY_SIGN_IN_REQUEST = 'AUTH/VERIFY_SIGN_IN/REQUEST';
export const VERIFY_SIGN_IN_SUCCESS = 'AUTH/VERIFY_SIGN_IN/SUCCESS';
export const VERIFY_SIGN_IN_FAILURE = 'AUTH/VERIFY_SIGN_IN/FAILURE';
export const RESEND_VERIFY_CODE_REQUEST = 'AUTH/RESEND_VERIFY_CODE/REQUEST';
export const RESEND_VERIFY_CODE_SUCCESS = 'AUTH/RESEND_VERIFY_CODE/SUCCESS';
export const RESEND_VERIFY_CODE_FAILURE = 'AUTH/RESEND_VERIFY_CODE/FAILURE';

export const SIGN_OUT_REQUEST = 'AUTH/SIGN_OUT/REQUEST';
export const SIGN_OUT_SUCCESS = 'AUTH/SIGN_OUT/SUCCESS';
export const SIGN_OUT_FAILURE = 'AUTH/SIGN_OUT/FAILURE';

export const SIGN_OUT_EMERGENCY = 'AUTH/SIGN_OUT/EMERGENCY';

export const LOAD_SESSION_REQUEST = 'AUTH/LOAD_SESSION/REQUEST';
export const LOAD_SESSION_SUCCESS = 'AUTH/LOAD_SESSION/SUCCESS';
export const LOAD_SESSION_FAILURE = 'AUTH/LOAD_SESSION/FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'AUTH/FORGOT_PASSWORD/REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'AUTH/FORGOT_PASSWORD/SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'AUTH/FORGOT_PASSWORD/FAILURE';

export const FORGOT_PASSWORD_SUBMIT_REQUEST = 'AUTH/FORGOT_PASSWORD_SUBMIT/REQUEST';
export const FORGOT_PASSWORD_SUBMIT_SUCCESS = 'AUTH/FORGOT_PASSWORD_SUBMIT/SUCCESS';
export const FORGOT_PASSWORD_SUBMIT_FAILURE = 'AUTH/FORGOT_PASSWORD_SUBMIT/FAILURE';

export const SET_AUTH_STEP = 'AUTH/SET_AUTH_STEP';

export const IMPERSONATE_USER_ID = 'AUTH/USER/IMPERSONATE_USER/START_REQUEST';
export const IMPERSONATE_USER_ID_SUCCESS = 'AUTH/USER/IMPERSONATE_USER/START_SUCCESS';
export const IMPERSONATE_USER_ID_FAILURE = 'AUTH/USER/IMPERSONATE_USER/START_FAILURE';

export const STOP_IMPERSONATE_USER_ID = 'AUTH/USER/IMPERSONATE_USER/STOP_REQUEST';
export const STOP_IMPERSONATE_USER_ID_SUCCESS = 'AUTH/USER/IMPERSONATE_USER/STOP_SUCCESS';
export const STOP_IMPERSONATE_USER_ID_FAILURE = 'AUTH/USER/IMPERSONATE_USER/STOP_FAILURE';
